export default __webpack_public_path__ + "static/media/logo.f10eb3a0.png";